import React, { useRef, useEffect } from 'react';
import {
  ToastOutsiderAlert,
  ToastWrapper,
  ToastTitle,
  ToastText,
  SuccessIcon,
  ErrorIcon,
  CloseIconWrapper,
  CloseIcon
} from './Toast.styles';

const getIconType = (type: string) => {
  const size = { width: 20, height: 20 };
  const typeIcons: Record<string, React.ReactNode> = {
    error: <ErrorIcon {...size} />,
    success: <SuccessIcon {...size} />
  };
  return typeIcons[type] || null;
};

type OwnProps = {
  animationClass?: string;
  closeToast?: () => void;
  persist?: boolean;
  showFor?: number;
  text?: string;
  title?: string;
  type?: string;
};

export type ToastProps = OwnProps;

const noop = () => {};

export default function Toast({
  animationClass = '',
  closeToast = noop,
  persist = false,
  showFor = 3500,
  text = 'Unfortunately, we were unable to process your request. Please try again in a few minutes.',
  title = '',
  type = 'info'
}: OwnProps) {
  const toastWrapperRef = useRef<HTMLDivElement>(null);

  let toastTimeout = 0;

  useEffect(() => {
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeToast();
    });
    if (!persist && showFor) {
      toastTimeout = window.setTimeout(() => {
        closeToast();
      }, showFor);
    }
    return () => {
      clearTimeout(toastTimeout);
    };
  }, []);

  function closeToastWhenClickOutside() {
    function handleClickOutside(event: MouseEvent) {
      if (toastWrapperRef.current && !toastWrapperRef.current.contains(event.target as Node)) {
        closeToast();
      }
    }

    useEffect(() => {
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, []);
  }

  closeToastWhenClickOutside();

  return (
    <ToastOutsiderAlert ref={toastWrapperRef}>
      <ToastWrapper type={type} className={animationClass}>
        <CloseIconWrapper onClick={() => closeToast()}>
          <CloseIcon width={13} height={13} />
        </CloseIconWrapper>
        {getIconType(type)}
        <ToastTitle className="toast-title">{title}</ToastTitle>
        <ToastText className="toast-text">{text}</ToastText>
      </ToastWrapper>
    </ToastOutsiderAlert>
  );
}
